import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Modal } from '../../../../../components';
import { renameEngagementAcc } from '../../../../../store/deals/deals.actions';
import { RootState } from '../../../../../store/store';

type Props = {
  onClose: () => void;
  open: boolean;
};

export const RenameAccountModal: React.FC<Props> = ({
  onClose,
  open,
}: Props): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { currentDeal } = useSelector((state: RootState) => state.deals);

  const [inputValue, setInputValue] = useState('');

  const dispatch = useDispatch();

  const updateName = () => {
    if (user && inputValue && currentDeal) {
      dispatch(
        renameEngagementAcc(
          user.orgId,
          user.userId,
          currentDeal.account.accountId,
          inputValue
        )
      );
      setInputValue('');
      onClose();
    }
  };

  const closeAndExit = () => {
    setInputValue('');

    onClose();
  };

  const changeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value);
  };

  const onEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e?.key === 'Enter') {
      updateName();
    }
  };

  const createFieldErrorMessage = () => {
    let error = '';

    if (inputValue.length > 50) {
      error = 'You’ve reached the maximum character limit';
    }

    return error;
  };

  const attrs = {
    Modal: {
      title: '',
      onClose: closeAndExit,
      open,
    },

    body: {
      wrapper: {
        className: 'rename-account',
      },

      title: {
        className: 'rename-account-title',
      },

      Input: {
        label: '',
        value: inputValue,
        onChange: changeInputValue,
        name: 'lastName',
        className: 'rename-account-input',
        error: createFieldErrorMessage(),
        errorOnTheRight: true,
        placeholder: 'Please enter new account name',
        isDealsRenameAcc: true,
        onKeyPress: onEnterPress,
      },

      buttons: {
        wrapper: {
          className: 'rename-account__buttons',
        },

        save: {
          className: 'rename-account__buttons-save',
          onClick: updateName,
        },

        cancel: {
          className: 'rename-account__buttons-cancel',
          onClick: closeAndExit,
        },
      },
    },
  };

  return (
    <Modal {...attrs.Modal}>
      <div {...attrs.body.wrapper}>
        <div {...attrs.body.title}>Rename Account</div>
        <Input {...attrs.body.Input} />
        <div {...attrs.body.buttons.wrapper}>
          <button {...attrs.body.buttons.save}>Save</button>
          <button {...attrs.body.buttons.cancel}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};
